
import { Options, Vue } from "vue-class-component";
import Turret from "@/entities/Turret";
import Card from "@/components/common/Card.vue";

@Options({
  components: { Card },
  emits: ["loaded"],
  props: {
    turret: {
      type: Turret,
    },
  },
})
export default class TurretContract extends Vue {
  private contractCode = "";

  loadContract(): void {
    const files = (document.querySelector("#contract") as HTMLInputElement)
      .files;

    const file = files ? files[0] : null;
    if (file) {
      const reader = new FileReader();
      reader.readAsText(file, "UTF-8");
      reader.onload = (evt) => {
        if (!evt.target?.result) {
          return;
        }
        this.contractCode = evt.target.result.toString();
        this.$emit("loaded", this.contractCode);
      };
      reader.onerror = function (evt) {
        console.error(evt);
      };
    }
  }
}
